import { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import { getEvents, getEventsinner } from "../Service/Api";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const CalendarPage = () => {
  const [events, setEvents] = useState([]);
  const [currentView, setCurrentView] = useState("month");
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getEventsinner();
        console.log("Raw API Data:", res);

        // Filter Academic Calendar items
        const calendarData = res?.filter(
          (item) =>
            item?.category &&
            item.category.toLowerCase().trim() === "academiccalender"
        );

        // Format data for react-big-calendar
        const formattedEvents = calendarData.map((item) => {
          // Combine date + time (if time exists)
          const startMoment = item.time
            ? moment(`${item.date} ${item.time}`, [
                "YYYY-MM-DD HH:mm",
                "YYYY-MM-DD H:mm",
              ])
            : moment(item.date, ["YYYY-MM-DD", "DD-MM-YYYY"]);

          return {
            title: item.title || "No Title",
            start: startMoment.toDate(),
            end: startMoment.toDate(), // single-day event
            allDay: !item.time, // treat as all-day if no specific time
            desc: item.description || "",
          };
        });

        console.log("Formatted Events:", formattedEvents);
        setEvents(formattedEvents);
      } catch (err) {
        console.error("❌ Failed to fetch calendar data:", err);
      }
    };

    fetchData();
  }, []);

  const homeMenu = [
    { label: "Latest Update", link: "/news" },
    { label: "Testimonials", link: "/testimonial" },
    { label: "School Calendar", link: "/calender" },
    { label: "CBSE Circulars", link: "/circular" },
    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    { label: "Fortnightly School Magazine", link: "/fortnightlyMagazine" },
    { label: "Carpe Diem'22", link: "/carpediem" },
  ];

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-school.jpg" />
      <Menu MenuItem={homeMenu} />

      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="School Calendar (Pre Nursery - XII)"
                breadEnd="School Calendar (Pre Nursery - XII)"
                breadMid="School Calendar (Pre Nursery - XII)"
              />
            </div>
          </div>

          <div className="row">
            <h2 className="mb-4">Academic Session 2025-26</h2>

            <div className="col-md-12">
              <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
                defaultDate={new Date()}
                view={currentView}
                onView={setCurrentView}
                date={currentDate}
                onNavigate={setCurrentDate}
                views={["month", "week", "day", "agenda"]}
                popup
                tooltipAccessor="desc"
                eventPropGetter={() => ({
                  style: {
                    backgroundColor: "#00a651",
                    color: "#fff",
                    borderRadius: "4px",
                    padding: "2px 5px",
                    border: "none",
                    fontSize: "0.85rem",
                  },
                })}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CalendarPage;
